import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TableTransactionsReservaService } from './table-transactions-reserva.service';
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { saveAs } from 'file-saver';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ReservaGgrService } from '../reserva-ggr/reserva-ggr/reserva-ggr.service';


@Component({
  selector: 'app-table-transactions-reserva',
  templateUrl: './table-transactions-reserva.component.html',
  styleUrls: ['./table-transactions-reserva.component.scss'],
  providers: [TableTransactionsReservaService, DecimalPipe, DatePipe]
})
export class TableTransactionsReservaComponent {
  @Input() accountIdGeneric = '';
  @ViewChild('transactionDetailsModal') private transactionDetailsTpl!: TemplateRef<any>;
  public selectedTransaction: any;
  public selectedCrypto: any = null;
  public canDownloadReceipt = false;
  public canResendWebhook = false;
  public tableRowForReceipt: any = null
  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public transactionType: string = '';
  public selectedStatus: string = '';
  public selectedOrigin: string = '';
  public selectedApplciation: string = '';
  public personName: string = '';
  public searchType: string = '';
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;
  public receiptTemplate: string = '';
  public bankProvider: Array<any> = [];
  public nameColumn: string = '';
  public account: any;
  public transactions: Array<any> = [];
  public isLoading: boolean = true;
  public startDateIso?: string;
  public endDateIso?: string;
  public pad(n: number) { return String(n).padStart(2, '0'); }
  public accountOriginCurrency: string = '';
  public isReprocessing = false;
  public isReservaMode = false;
  langChangeSub!: Subscription;

  constructor(private reservaGgrService: ReservaGgrService,
    private tableTransactionsReservaService: TableTransactionsReservaService,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private translate: TranslateService,
    private modal: NgbModal,
    private datePipe: DatePipe,
    private decimal: DecimalPipe) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    this.selectedStatus = 'REALIZADO';
    this.getReserveAccounts();
  }


  async ngOnInit(): Promise<void> {
    this.setTranslatedNameColumn();

    try {
      const acc = await this.tableTransactionsReservaService.getAccount();
      this.isReservaMode = /RESERVA/i.test(acc?.nameColumn || '');
    } catch {
      this.isReservaMode = false;
    }

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.setTranslatedNameColumn();
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['accountIdGeneric']) this.getTransactions();
  }

  mapOrigin(v: any): string {
    const s = (v ?? '').toString();
    return (this.isReservaMode && s === 'COMISSÃO') ? 'RESERVA' : s;
  }

  async getReserveAccounts(): Promise<void> {
    try {
      const account = await this.reservaGgrService.getAccount();
      this.account = account;
      this.accountIdGeneric = account.listsAccountTef?.[0]?.id ?? '';
      this.resolveAccountOriginCurrency();
      this.getTransactions();
    } catch {
      this.toastr.error('Não foi possível carregar a conta');
    }
  }

  private resolveAccountOriginCurrency() {
    const id = (this.accountIdGeneric || '').trim();
    const arr = Array.isArray(this.account?.listsAccountTef)
      ? this.account.listsAccountTef
      : [];

    const hit = arr.find((it: any) => (typeof it === 'string' ? it : it?.id) === id);
    this.accountOriginCurrency =
      (typeof hit === 'object' ? hit?.originCurrency : undefined) || '';
  }

  setTranslatedNameColumn(): void {
    this.translate.get(['common.license', 'common.split']).subscribe(translations => {
      if (this.account?.nameColumn?.includes('LICENCIADO')) {
        this.nameColumn = translations['common.license'];
      } else {
        this.nameColumn = translations['common.split'];
      }
    });
  }

  isValidPixDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-02-05T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  isValidTefDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-05-02T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  getTransactions() {
    const id = (this.accountIdGeneric || '').trim();

    if (!id) {
      this.isLoading = false;
      this.transactions = [];
      this.total = 0;
      return;
    }

    let dateInitialFormat: string;
    let dateFinalFormat: string;

    this.isLoading = true;

    if (this.startDateIso && this.endDateIso) {
      dateInitialFormat = this.startDateIso;
      dateFinalFormat = this.endDateIso;
    } else {
      const y1 = this.dataInitial.year, m1 = this.pad(this.dataInitial.month), d1 = this.pad(this.dataInitial.day);
      const y2 = this.dataFinal.year, m2 = this.pad(this.dataFinal.month), d2 = this.pad(this.dataFinal.day);
      dateInitialFormat = `${y1}-${m1}-${d1}T00:00:00`;
      dateFinalFormat = `${y2}-${m2}-${d2}T23:59:59`;
    }

    this.reservaGgrService
      .getTransactionsExtrato(dateInitialFormat, dateFinalFormat, this.transactionType, this.selectedStatus,
        this.selectedOrigin, this.selectedApplciation, this.personName,
        this.page, this.pageSize, this.searchType, id, this.accountOriginCurrency)
      .subscribe({
        next: v => {
          this.transactions = Array.isArray(v?.transactions) ? v.transactions : [];
          this.total = Number(v?.total) || 0;
          this.isLoading = false;
        },
        error: () => {
          this.transactions = [];
          this.total = 0;
          this.isLoading = false;
        }
      });
  }


  public getBankProvider() {
    this.tableTransactionsReservaService.getBankProvider().subscribe(
      value => {
        this.bankProvider = value.data;
      }
    )
  }

  public getAccount() {
    this.tableTransactionsReservaService.getAccount().then(
      value => {
        this.account = value;
        if (this.account?.nameColumn) {
          if (this.account.nameColumn.includes('LICENCIADO')) {
            this.nameColumn = this.translate.instant('common.license');
          } else {
            this.nameColumn = this.translate.instant('common.split');
          }
        }
      }
    ).catch(error => {
      console.error('Error fetching account:', error);
    });
  }

  pageChange() {
    this.getTransactions();
  }

  fmtDate(d?: string) {
    return d ? this.datePipe.transform(d, 'dd/MM/yyyy HH:mm:ss', 'UTC') : '-';
  }

  fmtMoney(v: number) {
    return this.decimal.transform(v, '1.2-2', 'pt-BR');
  }

  formatStatusClass(status: string): string {
    return 'status-' + (status || '').toLowerCase().replace(/ /g, '-');
  }

  openDetails(row: any): void {
    this.tableRowForReceipt = row;

    this.canDownloadReceipt =
      row.tipo === 'Saque' &&
      (
        (row.origem === 'PIX' && this.isValidPixDate(row.data)) ||
        (row.origem === 'TEF' && this.isValidTefDate(row.data))
      );

    this.canResendWebhook =
      ['REALIZADO', 'CANCELADO'].includes(row.status) &&
      ['API', 'TEF'].includes(row.aplicacao);

    this.tableTransactionsReservaService
      .getTransactionDetail(row.codigo, this.accountOriginCurrency)
      .then(resp => {
        const detail = resp.transaction ?? resp;
        this.selectedTransaction = {
          ...detail,
          cryptoTransaction: resp.cryptoTransaction ?? null,
          wallet: resp.wallet ?? null,
          symbol: resp.symbol ?? null
        };
        this.modal.open(this.transactionDetailsTpl, { centered: true, backdrop: 'static', windowClass: 'tall-modal', scrollable: true, size: 'lg' });
      })
      .catch(() => this.toastr.error('Erro ao buscar detalhes'));
  }

  async downloadReceipt(transaction: any) {
    this.toastr.success('Seu comprovante está sendo gerado', 'Sucesso', {
      timeOut: 3000,
      positionClass: 'toast-top-right',
    });

    const response = await firstValueFrom(this.pdfService.reportWithdraw(transaction));

    const byteCharacters = atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);


    const blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, 'comprovante.pdf');
  }

  async resendWebhook(transaction: any) {
    if (this.isReprocessing) return;
    this.isReprocessing = true;

    this.toastr.info('Reenviando webhook…', '', { timeOut: 2000 });

    try {
      await this.tableTransactionsReservaService
        .resendWebhook([transaction.id], this.accountOriginCurrency);
      this.toastr.success('Webhook reenviado com sucesso');
    } catch {
      this.toastr.error('Falha ao reenviar webhook');
    } finally {
      this.isReprocessing = false;
    }
  }
}



